import React, { useState } from 'react';
import { adminAuthService } from '../services/adminAuth';
import '../styles/ForgotPasswordModal.css';

const ForgotPasswordModal = ({ isOpen, onClose, onSuccess }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email.trim()) {
      setError('Please enter your email address');
      setLoading(false);
      return;
    }

    const result = await adminAuthService.requestPasswordReset(email.trim());

    if (result.success) {
      setSuccess(true);
      setEmail('');
      if (onSuccess) onSuccess(result.token);
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 2000);
    } else {
      setError(result.error || 'Failed to send reset link');
    }

    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="forgot-password-overlay" onClick={onClose}>
      <div className="forgot-password-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h2>Reset Password</h2>

        {success ? (
          <div className="success-message">
            <p>Password reset link has been sent to your email.</p>
            <p>Please check your inbox for further instructions.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="reset-email">Email Address</label>
              <input
                id="reset-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                disabled={loading}
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" disabled={loading} className="reset-button">
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <p className="modal-footer">
          Remember your password? <button type="button" className="link-button" onClick={onClose}>Back to Login</button>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
